import React from 'react'
import { Flex } from '@jisr-hr/design-system'
import JisrLoader from 'components/global/JisrLoader'
import { getMonthlyDeduction } from 'utils/string'
import { loanRequestCreate } from 'redux/actions/loanRequestActions'
import { useDispatch } from 'react-redux'
import { useRequest } from '../../RequestProvider'
import { LoanDetails, Reason, Profile, InstallmentCalculation } from '../../components/forms'

const LoanRequest = () => {
  const dispatch = useDispatch()
  const {
    setOnSubmit,
    setInitialValues,
    vars: { id, employee },
    drawerToggle,
    actionCallback,
  } = useRequest()

  const onSubmit = (val) => {
    const newVal = { ...val }
    if (newVal.installment_type === 'no_of_months') {
      newVal.monthly_deduction = getMonthlyDeduction(newVal.amount, newVal.no_of_months)
      delete newVal.no_of_months
    }
    delete newVal.installment_type
    return dispatch(loanRequestCreate(id, newVal)).then(() => {
      drawerToggle()
      if (actionCallback) {
        actionCallback()
      }
    })
  }

  React.useEffect(() => {
    setOnSubmit(onSubmit)
    setInitialValues({
      installment_type: 'monthly_deduction',
    })

    return () => {
      setOnSubmit(() => {})
      setInitialValues({})
    }
  }, [])

  return (
    <Flex
      flexCol
      style={{ gap: '16px' }}
    >
      {false && <JisrLoader absolute />}
      <Profile employee={employee} />
      <LoanDetails />
      <InstallmentCalculation stopReloadTypes />
      <Reason />
    </Flex>
  )
}

export default LoanRequest
